import { createFileRoute, redirect } from '@tanstack/react-router';
import { destinationSearch } from '@/lib/destination';
import { SignedOutPage } from '@/page/SignedOutPage';

/** /sign-in and Clerk's own steps under it, such as /sign-in/factor-one. */
export const Route = createFileRoute('/sign-in/$')({
  validateSearch: destinationSearch,
  beforeLoad: ({ context, search }) => {
    if (context.account()) throw redirect({ href: search.redirect_url ?? '/', replace: true });
  },
  component: SignInRoute,
});

function SignInRoute() {
  const { redirect_url } = Route.useSearch();
  return <SignedOutPage destination={redirect_url ?? '/'} />;
}
